import { render, staticRenderFns } from "./Bumps.vue?vue&type=template&id=24416253"
import script from "./Bumps.vue?vue&type=script&lang=js"
export * from "./Bumps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports